import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import i18nOptions from "src/services/i18n-options";

i18next.use(initReactI18next).use(HttpApi).use(LanguageDetector).init(i18nOptions);

export default i18next;
